export default __webpack_public_path__ + "signup-backdrop-client.8a0658a9.jpg";